import useRWDStateHook from './useRWDStateHook';
import useHeaderTitleHook from './useHeaderTitleHook';

export const useRWDState = useRWDStateHook;
export const useHeaderTitle = useHeaderTitleHook;
